import { cx, css } from '@fable/theme'
import { TransitionElement } from '@fable/components'
import { BookListItem } from '@fable/types'
import { usePreloadImage } from '@fable/hooks'
import BooklistDefaultIcon from '../../assets/icons/components/BooklistDefaultIcon'

const BookListThumbnail: React.VFC<{
  bookListData: BookListItem
  className?: string
}> = ({ bookListData, className }) => {
  const image = usePreloadImage(bookListData.cover_image, 300)

  return (
    <div
      className={cx(
        css`
          background-color: ${bookListData.background_color};
          padding: 12px;
          border-radius: 8px;
        `,
        className
      )}
    >
      {image?.src?.length ? (
        <TransitionElement transitionType="fadeIn">
          <img
            className={css`
              width: 100%;
              box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
              border-radius: 4px;
            `}
            src={image.src}
            alt={`${bookListData.name} book list`}
          />
        </TransitionElement>
      ) : (
        <div
          className={css`
            width: 100%;
            svg {
              width: inherit;
              height: auto;
            }
          `}
        >
          <BooklistDefaultIcon />
        </div>
      )}
    </div>
  )
}

export default BookListThumbnail
